import { apiClient } from './client';

const multipartHeaders = { 'Content-Type': 'multipart/form-data' };

export const authApi = {
  login:          (data)          => apiClient.post('/auth/login', data),
  register:       (data)          => apiClient.post('/auth/register', data),
  refreshToken:   (refreshToken)  => apiClient.post('/auth/refresh-token', { refreshToken }),
  logout:         ()              => apiClient.post('/auth/logout'),
  changePassword: (data)          => apiClient.put('/auth/change-password', data),
  getProfile:     ()              => apiClient.get('/users/profile'),
  updateProfile:  (data)          => apiClient.put(
    '/users/profile', data,
    data instanceof FormData ? { headers: multipartHeaders } : {},
  ),
  forgotPassword: (data)          => apiClient.post('/auth/forgot-password', data),
  resetPassword:  (data)          => apiClient.post('/auth/reset-password', data),
};
